import {AssignmentCenterService} from '@ac/root';
import {Observable} from 'rxjs';

export class FallbackService extends AssignmentCenterService {
	public isLoggedIn(): Observable<boolean> {
		return this.httpClient.studentApi.get<boolean>('login', 'is-logged-in').asObservable();
	}
}